import { Injectable } from '@angular/core'

import { SESSION_STORAGE_CONSTANTS_CAAS_CONTENT } from '../../constants/constant.content'
@Injectable()
export class ProductTypeModel {
  assetCaas
  public productType = {
    mf: {
      id: 'mf',
      rule: 'mf',
      text: '',
      value: false,
    },
    etf: {
      id: 'etf',
      rule: 'etf',
      text: '',
      value: false,
    },
    colTrust: {
      id: 'colTrust',
      rule: 'collTrusts',
      text: '',
      value: false,
    },
  }
  public isProductTypeClicked = false
  constructor() {
    const aemCassDataFromSession = sessionStorage.getItem(
      SESSION_STORAGE_CONSTANTS_CAAS_CONTENT,
    )
    const parsedCaasJson = JSON.parse(aemCassDataFromSession)
    if (parsedCaasJson.data.fd3filtersList) {
      this.assetCaas = parsedCaasJson.data.fd3filtersList.items[0]
      this.productType = {
        mf: {
          id: 'mf',
          rule: 'mf',
          text: this.assetCaas.mutualFunds,
          value: false,
        },
        etf: {
          id: 'etf',
          rule: 'etf',
          text: this.assetCaas.etf,
          value: false,
        },
        colTrust: {
          id: 'colTrust',
          rule: 'collTrusts',
          text: this.assetCaas.trusts,
          value: false,
        },
      }
    }
  }
}
